import { motion } from 'framer-motion';
import { Check } from '@phosphor-icons/react';

import pt from '../../../locales/pt';
import { formatEUR } from '../../../utils/money';
import { formatMonthLabel, targetDateToMonthValue } from '../../../utils/goalWizardUtils';

export function SmartGoalDoneStep({
  isEdit,
  isChecklist,
  name,
  why,
  imageUrl,
  amount,
  monthValue,
  targetDate,
  monthly,
}) {
  const copy = pt.goals.wizard.done;
  const ym = monthValue || targetDateToMonthValue(targetDate);
  const dateLabel = formatMonthLabel(ym);
  const subtitleLine = isChecklist
    ? dateLabel
    : `${formatEUR(amount || 0).replace(/\s*€$/, '').trim()} € até ${dateLabel}`;

  return (
    <div className="flex flex-col pt-2">
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 280, damping: 20 }}
        className="overflow-hidden rounded-3xl shadow-[0_22px_44px_-20px_rgba(28,25,23,0.5)]"
      >
        <div className="relative h-[230px]">
          {imageUrl ? (
            <img src={imageUrl} alt="" className="h-full w-full object-cover" />
          ) : (
            <div className="h-full w-full bg-gradient-to-br from-sage-500 to-sage-800" />
          )}
          <div
            className="absolute inset-0 bg-gradient-to-t from-[rgba(28,25,23,0.7)] to-transparent"
            aria-hidden
          />
          <div className="absolute left-3.5 top-3.5 inline-flex items-center gap-1.5 rounded-full bg-white/92 px-2.5 py-1 text-[11px] font-bold text-sage-700">
            <Check className="h-[13px] w-[13px]" weight="bold" aria-hidden />
            {isEdit ? copy.badgeEdit : copy.badge}
          </div>
          <div className="absolute bottom-4 left-[18px] right-[18px]">
            <p className="font-display text-[23px] font-bold leading-tight tracking-tight text-white">
              {name}
            </p>
            <p className="mt-1 text-[13.5px] text-white/88">{subtitleLine}</p>
          </div>
        </div>

        <div className="bg-card px-[18px] py-4">
          {!isChecklist && monthly != null ? (
            <div className="flex items-center justify-between">
              <span className="text-[13px] text-muted-foreground">{copy.monthlyRow}</span>
              <span className="font-display text-lg font-bold tabular-nums text-sage-600 dark:text-sage-400">
                {formatEUR(monthly)}
              </span>
            </div>
          ) : null}
          {why?.trim() ? (
            <div
              className={
                !isChecklist && monthly != null
                  ? 'mt-3.5 border-t border-border pt-3.5'
                  : ''
              }
            >
              <p className="text-[10.5px] font-bold uppercase tracking-wide text-muted-foreground">
                {copy.whyLabel}
              </p>
              <p className="mt-1.5 font-display text-sm font-medium italic leading-relaxed text-foreground/80">
                “{why.trim()}”
              </p>
            </div>
          ) : null}
        </div>
      </motion.div>

      <div className="mt-[18px] text-center">
        <h1 className="font-display text-[22px] font-semibold tracking-tight text-foreground">
          {copy.title}
        </h1>
        <p className="mt-2 text-[13.5px] leading-relaxed text-muted-foreground">{copy.subtitle}</p>
      </div>
    </div>
  );
}

export default SmartGoalDoneStep;
